<template>
  <v-card width="250" class="list-card" elevation="0">
    <v-list two-lines class="py-0 list-item" :class="[onPath ? 'on-path' : '']">
      <v-list-item class="pl-0" @click="selectItem(item)">
        <v-list-item-action class="mx-0 list-tile-action">
          <v-checkbox v-model="item.picked" color="primary" hide-details single-line @change="pickedItem(item)" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <v-tooltip top open-delay="1000">
              <template v-slot:activator="{ on }">
                <a v-if="item.isProduct" :href="`#/produtos/detalhes-produto/${item.id}`">
                  <span v-on="on">{{ item.name }}</span>
                </a>

                <span v-else v-on="on">{{ item.name }}</span>
              </template>
              <span class="item-name">{{ item.name }}</span>
            </v-tooltip>
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ $tc('produtos.arvoreProdutos.quantidadeItens', quantity(item), { quantidade: quantity(item) }) }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <mf-icon>keyboard_arrow_right</mf-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object,
    onPath: Boolean,
  },
  methods: {
    quantity(item) {
      if (!item.children) return 0
      return item.children.length
    },
    selectItem(item) {
      if (item.children) this.$emit('selected-item', item)
    },
    pickedItem(item) {
      this.$emit('picked-item', item)
    },
  },
}
</script>

<style lang="scss">
.list-card {
  border-radius: 0 !important;
  .on-path {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .list-item {
    .v-list__tile {
      padding-left: 0;
    }
    .v-list__tile__avatar {
      min-width: 40px;
    }
    .v-list__tile__title {
      span {
        font-size: 12px;
      }
    }
    .v-list__tile__sub-title {
      font-size: 12px;
    }
    .v-list__tile__action {
      min-width: 24px;
    }
  }
}
.list-tile-action {
  padding-left: 8px;
}
</style>
